import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { Task } from '@entities/task';
import { EntityService } from '@app/shared/services/entity.service';
import { select, Store } from '@ngrx/store';
import {
   getCurrentUserTeamMemberId,
   getOrganizationId,
} from '@app/user-org/state/user-org.selectors';
import { OrgEntityService } from '@app/shared/services/org-entity.service';
import { State } from '@app/app.state';
import { COLLECTION_NAMES } from '@app/shared/services/collection-names';
import { AppAreas } from '@entities/enums/app-areas';
import { PermissionsFacade } from '@app/shared/state/permissions.facade';
import { WhereFilterOp, where } from '@angular/fire/firestore';
import { PermissionedEntity } from '@app/shared/interfaces/permissioned-entity.interface';

@Injectable()
export class TaskService implements EntityService<Task>, PermissionedEntity, OnDestroy {
   readonly COLLECTION_NAME: string = COLLECTION_NAMES.TASKS;
   entities$: Observable<Task[]>;

   private orgId$: Observable<string> = this.store.pipe(select(getOrganizationId));
   private teamMemberId$ = this.permissionsFacade.currentUserTeamMemberId$;
   private permissionGroup$ = this.permissionsFacade.currentUserPermissionGroup$;
   private orgEntityService = new OrgEntityService<Task>();

   constructor(private store: Store<State>, private permissionsFacade: PermissionsFacade) {
      this.orgEntityService.init(
         this.orgId$,
         this.COLLECTION_NAME,
         AppAreas.Documentation,
         this.permissionsFacade.usePermissionGroups$,
         this.permissionGroup$,
         this.assigneeFilter,
         this.teamMemberId$
      );
      this.entities$ = this.orgEntityService.entities$;
   }
   ngOnDestroy() {
      this.orgEntityService.destroy();
   }
   save(entity: Task, overwrite: boolean = false): Promise<Task> {
      return this.orgEntityService.save(entity, { overwrite });
   }
   batchSave(entities: Task[]): Promise<Task[]> {
      return this.orgEntityService.batchSave(entities);
   }
   delete(entity: Task): Promise<void> {
      return this.orgEntityService.delete(entity);
   }

   assigneeFilter(teamMemberId: string): Array<[string, WhereFilterOp, string]> {
      return [['assignees', 'array-contains', teamMemberId]];
   }
}
